import { getColorWithAlpha } from '@elfsight/lib-utils';
import { getInvertedColor } from '../../../../../../packages/widget-utils/src';
import type { FormAppearance, PricingTableSettings } from '../../../types';
import { defaultFormAppearance } from '../constants';

const FORM_BORDER_RADIUS = 8;

export function getFormAppearanceSettings({
  formAccentColor,
  formTextColor,
  formErrorColor,
  formSuccessColor
}: Pick<
  PricingTableSettings,
  'formAccentColor' | 'formTextColor' | 'formErrorColor' | 'formSuccessColor'
>): FormAppearance {
  const {
    submitButtonProps: { size: _size, text: _text, ...submitButtonProps }
  } = defaultFormAppearance;
  const halfTransparentTextColor = getColorWithAlpha(formTextColor, 0.5);

  return {
    ...defaultFormAppearance,
    fieldSpacing: 20,
    fieldActiveColor: formAccentColor,
    fieldHeadingColor: formTextColor,
    fieldLabelColor: formTextColor,
    fieldColor: formTextColor,
    fieldInsideLabelColor: halfTransparentTextColor,
    fieldHintColor: getColorWithAlpha(formTextColor, 0.7),
    fieldBorderRadius: FORM_BORDER_RADIUS,
    fieldBorderColor: getColorWithAlpha(formTextColor, 0.2),
    submitMessageTitleColor: formTextColor,
    submitMessageTextColor: formTextColor,
    submitMessageButtonColor: formAccentColor,
    submitButtonProps: {
      ...submitButtonProps,
      borderRadius: FORM_BORDER_RADIUS,
      color: formAccentColor,
      fontColor: getInvertedColor(formAccentColor)
    },
    widgetFooterTextColor: halfTransparentTextColor,
    widgetFooterLinksColor: formAccentColor,
    errorColor: formErrorColor,
    successColor: formSuccessColor
  };
}
